import { ca } from '@cian/analytics';

/**
 * Успешная регистрация
 */
export function trackRegistrationSuccess(socialType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Registration',
    action: 'success',
    label: socialType || ''
  });
}
/**
 * Подписка на новости
 */

export function trackWantsSubscription() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Subscription',
    action: 'send',
    label: 'news'
  });
}
/**
 * Показ попапа "Отправлено письмо"
 */

export function trackRegistrationDonePopup() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_email_popup_show'
  });
}
/**
 * Закрытие попапа "Отправлено письмо"
 */

export function trackRegistrationDonePopupClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_email_popup_got_it'
  });
}
/**
 * Введен неверный код
 */

export function trackRegistrationSmsValidationFail() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  });
}